"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var licenseStatus = [
    {
        id: 1,
        name: 'At Risk'
    },
    {
        id: 2,
        name: 'Behind Benchmark'
    },
    {
        id: 3,
        name: 'Exceeding Benchmark'
    }
];
exports.licenseStatus = licenseStatus;
//# sourceMappingURL=licenseStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/licenseStatus.js
// module id = 888
// module chunks = 0